import React from 'react';
import Loadable from 'react-loadable';
import LoadableLoading from 'components/LoadableLoading';

export const path = '/ppr/area/list';

const PageAreaListPpr: React.FC = (props) => {
  const AreaListPpr = Loadable.Map({
    loader: {
      page: () => import('./page'),
    },
    loading: LoadableLoading,
    render(loaded, loadedProps) {
      const Page = loaded.page.default;

      return <Page {...loaded} {...loadedProps} />;
    },
  });

  return <AreaListPpr {...props} />;
};

export default PageAreaListPpr;
